import React from 'react';
import PropTypes from 'prop-types';
import {
  StepsContainer,
  StepItem,
  StepCircle,
  StepLabel,
  Title,
  Description,
} from './components/StepsStyles';
import { useSteps } from './hooks/useSteps';

const Steps = ({ current = 0, items = [] }) => {
  const { processedItems } = useSteps({ current, items });

  return (
    <StepsContainer>
      {processedItems.map((item) => (
        <StepItem key={item.index} isCompleted={item.isCompleted}>
          <StepCircle status={item.status}>
            {item.status === 'completed' ? (
              <i className="fa fa-check" />
            ) : (
              item.index + 1
            )}
          </StepCircle>
          <StepLabel>
            <Title active={item.isActive}>{item.title}</Title>
            {item.description && <Description>{item.description}</Description>}
          </StepLabel>
        </StepItem>
      ))}
    </StepsContainer>
  );
};

Steps.propTypes = {
  current: PropTypes.number,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
    })
  ).isRequired,
};

Steps.defaultProps = {
  current: 0,
};

export default Steps;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Steps/Steps.jsx